import {
  IEmailDetail,
  IPatientDemographicsAction,
  IPatientDemographicsState,
  IPhoneDetail,
  IPhysicianDetail,
} from './patientDemographics.types'
import { PatientDemographicsConstants } from './patientDemographics.constants'
import { randomNumber } from '../../../utilities'

export const phoneDetailsInit = (): IPhoneDetail => {
  return {
    key: randomNumber().toString(),
    number: '',
    type: null,
    readonly: false,
  }
}

export const emailDetailsInit = (): IEmailDetail => {
  return {
    key: randomNumber().toString(),
    address: '',
    type: null,
  }
}

export const physicianDetailsInit: IPhysicianDetail = {
  key: '',
  physicianFirstName: '',
  physicianLastName: '',
  physicianMiddleName: '',
  physicianOtherName: null,
  physicianType: null,
}

export const initialPatientDemographicsState: IPatientDemographicsState = {
  servicePtID: '',
  patientRunID: '',
  texasWristband: '',
  texasWristbandReportTypeId: null,
  texasWristbandNemsis3: null,
  firstName: '',
  firstNamePNNV: null,
  middleInitial: '',
  lastName: '',
  lastNamePNNV: null,
  triageColor: null,
  triageColorPNNV: null,
  suffix: null,
  dOB: null,
  dOBPNNV: null,
  age: null,
  agePNNV: null,
  ageUnit: null,
  sSN: null,
  sSNPNNV: null,
  weight: null,
  weightPNNV: null,
  weightUnits: null,
  height: null,
  heightUnits: null,
  sex: null,
  sexPNNV: null,
  gender: null,
  genderPNNV: null,
  bloodType: null,
  race: [],
  racePNNV: null,
  driversLicense: '',
  dlState: null,
  address1: '',
  address2: '',
  addressPNNV: null,
  zipCode: '',
  city: null,
  cityPNNV: null,
  state: null,
  county: null,
  country: null,
  resident: null,
  altHomeResidence: null,
  altHomeResidencePNNV: null,
  citizenship: null,
  phoneDetails: [],
  phoneDetailsPNNV: null,
  emailDetails: [],
  dnr: [],
  physicianData: physicianDetailsInit,
  physicianDataList: [],
  physicianFirstName: '',
  physicianLastName: '',
  physicianMiddleName: '',
  physicianType: null,
  barriersToCare: [],
  preferredLanguage: [],
  __areDefaultsSet: false,
  barriersToCarePNNV: null,
}

export function patientDemographicsReducer(
  state: IPatientDemographicsState = initialPatientDemographicsState,
  action: IPatientDemographicsAction
): IPatientDemographicsState {
  switch (action.type) {
    case PatientDemographicsConstants.NOT_IMPLEMENTED:
      alert('Not implemented')
      return state
    case PatientDemographicsConstants.SET_PATIENT_ID:
      return { ...state, servicePtID: action.servicePtID }
    case PatientDemographicsConstants.SET_PATIENT_RUN_ID:
      return { ...state, patientRunID: action.patientRunID }
    case PatientDemographicsConstants.SET_TEXAS_WRISTBAND:
      return { ...state, texasWristband: action.texasWristband }
    case PatientDemographicsConstants.SET_FIRST_NAME:
      return { ...state, firstName: action.firstName }
    case PatientDemographicsConstants.SET_FIRST_NAME_PNNV:
      return { ...state, firstNamePNNV: action.firstNamePNNV }
    case PatientDemographicsConstants.SET_MIDDLE_INITIAL:
      return { ...state, middleInitial: action.middleInitial }
    case PatientDemographicsConstants.SET_LAST_NAME:
      return { ...state, lastName: action.lastName }
    case PatientDemographicsConstants.SET_LAST_NAME_PNNV:
      return { ...state, lastNamePNNV: action.lastNamePNNV }
    case PatientDemographicsConstants.SET_SUFFIX:
      return { ...state, suffix: action.suffix }
    case PatientDemographicsConstants.SET_TRIAGE_COLOR:
      return { ...state, triageColor: action.triageColor }
    case PatientDemographicsConstants.SET_TRIAGE_COLOR_PNNV:
      return { ...state, triageColorPNNV: action.triageColorPNNV }
    case PatientDemographicsConstants.SET_DOB:
      return { ...state, dOB: action.dOB }
    case PatientDemographicsConstants.SET_DOB_PNNV:
      return { ...state, dOBPNNV: action.dOBPNNV }
    case PatientDemographicsConstants.SET_AGE:
      return { ...state, age: action.age }
    case PatientDemographicsConstants.SET_AGE_PNNV:
      return { ...state, agePNNV: action.agePNNV }
    case PatientDemographicsConstants.SET_AGE_UNIT:
      return { ...state, ageUnit: action.ageUnit }
    case PatientDemographicsConstants.SET_SSN:
      return { ...state, sSN: action.sSN }
    case PatientDemographicsConstants.SET_SSN_PNNV:
      return { ...state, sSNPNNV: action.sSNPNNV }
    case PatientDemographicsConstants.SET_WEIGHT:
      return { ...state, weight: action.weight }
    case PatientDemographicsConstants.SET_WEIGHT_PNNV:
      return { ...state, weightPNNV: action.weightPNNV }
    case PatientDemographicsConstants.SET_HEIGHT:
      return { ...state, height: action.height }
    case PatientDemographicsConstants.SET_WEIGHT_UNITS:
      return { ...state, weightUnits: action.weightUnits }
    case PatientDemographicsConstants.SET_HEIGHT_UNITS:
      return { ...state, heightUnits: action.heightUnits }
    case PatientDemographicsConstants.SET_SEX:
      return { ...state, sex: action.sex }
    case PatientDemographicsConstants.SET_SEX_PNNV:
      return { ...state, sexPNNV: action.sexPNNV }
    case PatientDemographicsConstants.SET_GENDER:
      return { ...state, gender: action.gender }
    case PatientDemographicsConstants.SET_GENDER_PNNV:
      return { ...state, genderPNNV: action.genderPNNV }
    case PatientDemographicsConstants.SET_RACE:
      return { ...state, race: action.race }
    case PatientDemographicsConstants.SET_RACE_PNNV:
      return { ...state, racePNNV: action.racePNNV }
    case PatientDemographicsConstants.SET_BLOOD_TYPE:
      return { ...state, bloodType: action.bloodType }
    case PatientDemographicsConstants.SET_DRIVERS_LICENSE_NUMBER:
      return { ...state, driversLicense: action.driversLicense }
    case PatientDemographicsConstants.SET_DL_STATE:
      return { ...state, dlState: action.dlState }
    case PatientDemographicsConstants.SET_RUN_ID:
    case PatientDemographicsConstants.SET_ADDRESS_1:
      return { ...state, address1: action.address1 }
    case PatientDemographicsConstants.SET_ADDRESS_2:
      return { ...state, address2: action.address2 }
    case PatientDemographicsConstants.SET_ADDRESS_PNNV:
      return { ...state, addressPNNV: action.addressPNNV }
    case PatientDemographicsConstants.SET_ZIP_CODE:
      return { ...state, zipCode: action.zipCode }
    case PatientDemographicsConstants.SET_CITY:
      return { ...state, city: action.city }
    case PatientDemographicsConstants.SET_CITY_PNNV:
      return { ...state, cityPNNV: action.cityPNNV }
    case PatientDemographicsConstants.SET_STATE:
      return { ...state, state: action.state }
    case PatientDemographicsConstants.SET_COUNTY:
      return { ...state, county: action.county }
    case PatientDemographicsConstants.SET_COUNTRY:
      return { ...state, country: action.country }
    case PatientDemographicsConstants.SET_RESIDENT:
      return { ...state, resident: action.resident }
    case PatientDemographicsConstants.SET_ALT_HOME_RESIDENCE:
      return { ...state, altHomeResidence: action.altHomeResidence }
    case PatientDemographicsConstants.SET_ALT_HOME_RESIDENCE_PNNV:
      return { ...state, altHomeResidencePNNV: action.altHomeResidencePNNV }
    case PatientDemographicsConstants.SET_CITIZENSHIP:
      return { ...state, citizenship: action.citizenship }
    case PatientDemographicsConstants.SET_PATIENT_DEMOGRAPHICS:
      return { ...state, ...action.patientDemographics }
    case PatientDemographicsConstants.SET_DNR:
      return { ...state, dnr: action.dnr }
    case PatientDemographicsConstants.SET_BARRIERS_TO_CARE:
      return { ...state, barriersToCare: action.barriersToCare }
    case PatientDemographicsConstants.SET_BARRIERS_TO_CARE_PNNV:
      return { ...state, barriersToCarePNNV: action.barriersToCarePNNV }
    case PatientDemographicsConstants.SET_PREFERRED_LANGUAGE:
      return { ...state, preferredLanguage: action.preferredLanguage }
    case PatientDemographicsConstants.RESET_EMPLOYER:
      return { ...state, employer: undefined }
    case PatientDemographicsConstants.RESET_STATE:
      return {
        servicePtID: '',
        patientRunID: '',
        texasWristband: '',
        texasWristbandReportTypeId: null,
        texasWristbandNemsis3: null,
        firstName: '',
        firstNamePNNV: null,
        middleInitial: '',
        lastName: '',
        lastNamePNNV: null,
        suffix: null,
        triageColor: null,
        triageColorPNNV: null,
        dOB: null,
        dOBPNNV: null,
        age: null,
        agePNNV: null,
        ageUnit: null,
        sSN: null,
        sSNPNNV: null,
        weight: null,
        weightPNNV: null,
        weightUnits: null,
        height: null,
        heightUnits: null,
        sex: null,
        sexPNNV: null,
        gender: null,
        genderPNNV: null,
        bloodType: null,
        race: [],
        racePNNV: null,
        driversLicense: '',
        dlState: null,
        address1: '',
        address2: '',
        addressPNNV: null,
        zipCode: '',
        city: null,
        cityPNNV: null,
        state: null,
        county: null,
        country: null,
        resident: null,
        altHomeResidence: null,
        altHomeResidencePNNV: null,
        citizenship: null,
        phoneDetails: [],
        phoneDetailsPNNV: null,
        __phoneDetailsPNNVToggle: false,
        emailDetails: [],
        dnr: [],
        physicianData: physicianDetailsInit,
        physicianDataList: [],
        physicianFirstName: '',
        physicianLastName: '',
        physicianMiddleName: '',
        physicianType: null,
        barriersToCare: [],
        preferredLanguage: [],
        __areDefaultsSet: false,
        barriersToCarePNNV: null,
      }
    case PatientDemographicsConstants.SET_EMAIL_DETAILS:
      return { ...state, emailDetails: action.emailDetails }
    case PatientDemographicsConstants.SET_PHONE_DETAILS:
      return { ...state, phoneDetails: action.phoneDetails }
    case PatientDemographicsConstants.SET_PHONE_DETAILS_PNNV:
      return { ...state, phoneDetailsPNNV: action.phoneDetailsPNNV }
    case PatientDemographicsConstants.SET_PHONE_DETAILS_PNNV_TOGGLE:
      return { ...state, __phoneDetailsPNNVToggle: action.__phoneDetailsPNNVToggle }
    case PatientDemographicsConstants.ADD_PHONE:
      return { ...state, phoneDetails: [...state.phoneDetails, phoneDetailsInit()] }
    case PatientDemographicsConstants.ADD_EMAIL:
      return { ...state, emailDetails: [...state.emailDetails, emailDetailsInit()] }
    case PatientDemographicsConstants.SET_PHYSICIAN_DATA:
      return { ...state, physicianData: action.physicianData }
    case PatientDemographicsConstants.ADD_PHYSICIAN_LIST:
      return { ...state, physicianDataList: action.physicianDataList }
    case PatientDemographicsConstants.SET_PHYSICIAN_FIRSTNAME:
      return { ...state, physicianData: { ...state.physicianData, physicianFirstName: action.physicianFirstName } }
    case PatientDemographicsConstants.SET_PHYSICIAN_LASTNAME:
      return { ...state, physicianData: { ...state.physicianData, physicianLastName: action.physicianLastName } }
    case PatientDemographicsConstants.SET_PHYSICIAN_MIDDLENAME:
      return { ...state, physicianData: { ...state.physicianData, physicianMiddleName: action.physicianMiddleName } }
    case PatientDemographicsConstants.SET_PHYSICIAN_TYPE:
      return { ...state, physicianData: { ...state.physicianData, physicianType: action.physicianType } }
    case PatientDemographicsConstants.SET_PATIENT_DEMOGRAPHICS_DEFAULTS:
      return { ...state, __areDefaultsSet: action.__areDefaultsSet }
    case PatientDemographicsConstants.CLEAR_PHYSICIAN_DATA:
      return { ...state, physicianData: { ...physicianDetailsInit } }
    default:
      return state
  }
}
